import axios from '../../../build/http-requests/axios-common'

export default {
  state: {
    categorieFather: {},
    lastCategorieNumber: null,
    categorieToEdit: {},
    numberOfCategories: null,
    lastCategorieOrder: null
  },

  mutations: {
    SET_FATHER_CATEGORIE (state, categorie) {
      state.categorieFather = {
        id: categorie.id,
        description: categorie.description,
        number: categorie.number,
        lastChildren: categorie.lastChildren,
        isMainFather: categorie.isMainFather,
        order: categorie.order,
        initialBalance: categorie.initialBalance,
        balanceInitialDate: categorie.balanceInitialDate
      }
    },

    SET_LAST_CATEGORIE_ORDER (state, order) {
      state.lastCategorieOrder = order
    },

    CLEAN_LAST_CATEGORIE_ORDER (state) {
      state.lastCategorieOrder = null
    },

    CLEAN_FATHER_CATEGORIE (state) {
      state.categorieFather = {}
    },

    SET_CATEGORIE_TO_EDIT (state, categorie) {
      state.categorieToEdit = {
        id: categorie.id,
        fatherCategory: {
          id: categorie.fatherCategory ? categorie.fatherCategory.id : null,
          name: categorie.fatherCategory ? categorie.fatherCategory.nome : null,
          number: categorie.fatherCategory ? categorie.fatherCategory.numero : null
        },
        name: categorie.description,
        number: categorie.number,
        type: categorie.type,
        accountingId: categorie.accountingId,
        order: categorie.order,
        initialBalance: categorie.initialBalance,
        balanceInitialDate: categorie.balanceInitialDate
      }
    },

    CLEAN_CATEGORIE_TO_EDIT (state) {
      state.categorieToEdit = {}
    },

    RELOAD_CATEGORIE_LIST (state, flag) {
      state.reloadCategorieList = flag
    },

    SET_LAST_CATEGORIE_NUMBER (state, number) {
      state.lastCategorieNumber = number
    },

    CLEAN_LAST_CATEGORIE_NUMBER (state) {
      state.lastCategorieNumber = null
    },

    SET_CATEGORIES_QTY (state, qty) {
      state.numberOfCategories = qty
    }
  },

  actions: {
    getCategorie: ({ commit }, categorieId) => {
      return new Promise((resolve, reject) => {
        axios.get('/categories/find', { params: { categorieId: categorieId } }).then(response => {
          commit('SET_CATEGORIE_TO_EDIT', response.data)
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    getCategories: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.get(data.url, {
          params: {
            flTipoCategoria: data.flTipoCategoria,
            validarUso: data.validarUso
          }
        }).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    getMainCategories: ({ commit }, url) => {
      return new Promise((resolve, reject) => {
        axios.get(url).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    saveCategorie: ({ commit }, categorie) => {
      return new Promise((resolve, reject) => {
        axios.post('/categories', categorie).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    removeCategorie: ({ commit }, categorieId) => {
      return new Promise((resolve, reject) => {
        axios.delete('/categories', { params: { categorieId: categorieId } }).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    setCategorieFather: ({ commit }, categorie) => {
      return new Promise((resolve, reject) => {
        commit('SET_FATHER_CATEGORIE', categorie)
        resolve()
      })
    },

    cleanCategorieToEdit: ({ commit }) => {
      return new Promise((resolve, reject) => {
        commit('CLEAN_CATEGORIE_TO_EDIT')
        resolve()
      })
    },

    setReloadCategories: ({ commit }, flag) => {
      return new Promise((resolve, reject) => {
        commit('RELOAD_CATEGORIE_LIST', flag)
        resolve()
      })
    },

    cleanCategorieFather: ({ commit }) => {
      return new Promise((resolve, reject) => {
        commit('CLEAN_FATHER_CATEGORIE')
        resolve()
      })
    },

    setLastCategorieNumber: ({ commit }, number) => {
      return new Promise((resolve, reject) => {
        commit('SET_LAST_CATEGORIE_NUMBER', number)
        resolve()
      })
    },

    cleanLastCategorieNumber: ({ commit }) => {
      return new Promise((resolve, reject) => {
        commit('CLEAN_LAST_CATEGORIE_NUMBER')
        resolve()
      })
    },

    setLastCategorieOrder: ({ commit }, order) => {
      return new Promise((resolve, reject) => {
        commit('SET_LAST_CATEGORIE_ORDER', order)
        resolve()
      })
    },

    cleanLastCategorieOrder: ({ commit }) => {
      return new Promise((resolve, reject) => {
        commit('CLEAN_LAST_CATEGORIE_ORDER')
        resolve()
      })
    }
  },

  getters: {
    categorieFather: state => state.categorieFather,
    categorieToEdit: state => state.categorieToEdit,
    cleanCategorieToEdit: state => state.cleanCategorieToEdit,
    reloadCategorieList: state => state.reloadCategorieList,
    cleanCategorieFather: state => state.cleanCategorieFather,
    lastCategorieNumber: state => state.lastCategorieNumber,
    numberOfCategories: state => state.numberOfCategories,
    lastCategorieOrder: state => state.lastCategorieOrder
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/categories.js